import ListingDetailAircraftForm from '@Forms/ListingDetailAircraftForm';
import ListingDetailForm from '@Forms/ListingDetailForm';
import { validateLocation } from '@Utilities/LocationValidator';

class ListingDetailSection extends React.Component {

    //set the react state to the the same values as the model
    modelToState(props, setState) {

        var nBaseCat = 0;
        switch (props.model.InventoryType) {
            case "All":
                nBaseCat = 0;
                break;
            case "Construction Equipment":
                nBaseCat = 4;
                break;
            case "Forestry Equipment":
            case "Farm Equipment":
                nBaseCat = 464;
                break;
            case "Trucks":
                nBaseCat = 27;
                break;
            case "Trailers":
                nBaseCat = 28;
                break;
        }

        var TailNumber = "";
        if (props.model.CurrentSite == "Aircraft" && props.masterViewModel.SpecsViewModel.FormInputs["RegNumber"] != null)
            TailNumber = props.masterViewModel.SpecsViewModel.FormInputs["RegNumber"].Value;

        if (setState) {
            this.setState({
                specsViewModel: props.model.specsViewModel,
                updateMakeModel: props.model.updateMakeModel,
                SystemOfMeasurement: props.model.SystemOfMeasurement,
                ManufacturerSelected: props.model.ManufacturerSelected,
                ManufacturersList: props.model.ManufacturersList,
                ModelSelected: props.model.ModelSelected,
                ModelList: props.model.ModelList,
                CategorySelected: props.model.CategorySelected,
                CategoriesList: props.model.CategoriesList,
                allCategoryOptions: props.model.AllCategoriesList || props.model.allCategoryOptions,
                MakeOnlyCategoryOptions: props.model.AllCategoriesList,
                SerialVIN: props.model.SerialVIN,
                SerialVINSelection: props.model.SerialVINSelection,
                TailNumber: TailNumber,
                AllYears: props.model.Years,
                YearSelected: props.model.YearSelected != 0 ? props.model.YearSelected : props.model.Years[0],
                Years: props.model.Years,
                EquipmentIdentifier: props.model.EquipmentIdentifier,
                StockNumber: props.model.StockNumber,
                Condition: props.model.Condition,
                ConditionList: props.model.ConditionList,
                Description: props.model.Description,
                BaseCatID: props.model.BaseCatID,
                InventoryType: nBaseCat,
                IsAttachment: props.model.IsAttachment,
                Quantity: props.model.Quantity,
                Weight: props.model.Weight,
                FleetEvalElement: [],
                ValidFECategories: props.model.ValidFECategories,
                validFECat: props.model.validFECat,
                ShowFE: props.model.ShowFE,
                VinSerialVerify: props.model.VinSerialVerify,
                bModelIsRequired: true,
                LocationViewModel: props.masterViewModel.ContactViewModel.LocationViewModel,
                QueryString: props.model.QueryString,
                NextPageURL: props.model.NextPageURL,
                Translations: props.model.Translations,
                Progress: props.model.Progress,
                CurrentSite: props.model.CurrentSite,
                CatMakeModelValid: props.masterViewModel.CatMakeModelValid,
                HighlightErrors: props.model.HighlightErrors || {},
                FormErrors: props.model.FormErrors || [],
                InputErrors: props.model.InputErrors || {},
                MLAutofilled: props.model.MLAutofilled,
                AutofilledFields: props.model.AutofilledFields,
                IsRegisteredUser: props.masterViewModel.IsRegisteredUser,
                EmailVerified: props.masterViewModel.ContactViewModel ? props.masterViewModel.ContactViewModel.EmailVerified : false
            });
        }
        else {
            return {
                specsViewModel: props.model.specsViewModel,
                updateMakeModel: props.model.updateMakeModel,
                SystemOfMeasurement: props.model.SystemOfMeasurement,
                ManufacturerSelected: props.model.ManufacturerSelected,
                ManufacturersList: props.model.ManufacturersList,
                ModelSelected: props.model.ModelSelected,
                ModelList: props.model.ModelList,
                CategorySelected: props.model.CategorySelected,
                CategoriesList: props.model.CategoriesList,
                allCategoryOptions: props.model.AllCategoriesList || props.model.allCategoryOptions,
                MakeOnlyCategoryOptions: props.model.AllCategoriesList,
                SerialVIN: props.model.SerialVIN,
                SerialVINSelection: props.model.SerialVINSelection,
                TailNumber: TailNumber,
                AllYears: props.model.Years,
                YearSelected: props.model.YearSelected != 0 ? props.model.YearSelected : props.model.Years[0],
                Years: props.model.Years,
                EquipmentIdentifier: props.model.EquipmentIdentifier,
                StockNumber: props.model.StockNumber,
                Condition: props.model.Condition,
                ConditionList: props.model.ConditionList,
                Description: props.model.Description,
                BaseCatID: props.model.BaseCatID,
                InventoryType: nBaseCat,
                IsAttachment: props.model.IsAttachment,
                Quantity: props.model.Quantity,
                Weight: props.model.Weight,
                FleetEvalElement: [],
                ValidFECategories: props.model.ValidFECategories,
                validFECat: props.model.validFECat,
                ShowFE: props.model.ShowFE,
                VinSerialVerify: props.model.VinSerialVerify,
                bModelIsRequired: true,
                LocationViewModel: props.masterViewModel.ContactViewModel.LocationViewModel,
                QueryString: props.model.QueryString,
                NextPageURL: props.model.NextPageURL,
                Translations: props.model.Translations,
                Progress: props.model.Progress,
                CurrentSite: props.model.CurrentSite,
                CatMakeModelValid: props.masterViewModel.CatMakeModelValid,
                HighlightErrors: props.model.HighlightErrors || {},
                FormErrors: props.model.FormErrors || [],
                InputErrors: props.model.InputErrors || {},
                MLAutofilled: props.model.MLAutofilled,
                AutofilledFields: props.model.AutofilledFields,
                IsRegisteredUser: props.masterViewModel.IsRegisteredUser,
                EmailVerified: props.masterViewModel.ContactViewModel ? props.masterViewModel.ContactViewModel.EmailVerified : false
            };
        }
    }

    //The props is the model passed from the view(cshtml)
    constructor(props) {
        super(props);

        this.modelToState = this.modelToState.bind(this);
        this.state = this.modelToState(props, false);

        this.validatorListingDetail = this.validatorListingDetail.bind(this);
        this.validateCatMakeModel = this.validateCatMakeModel.bind(this);
        this.handleFormUpdate = this.handleFormUpdate.bind(this);
        this.handleCategoryUpdate = this.handleCategoryUpdate.bind(this);
        this.handleMasterViewUpdate = this.handleMasterViewUpdate.bind(this);
        this.ConfirmButton = this.ConfirmButton.bind(this);
        this.SkipButton = this.SkipButton.bind(this);

        //updates the parent's validator to use this method 
        var masterViewState = this.props.masterViewModel;
        masterViewState.validatorListingDetail = this.validatorListingDetail;
        this.props.handleFormUpdate(masterViewState);
        this.state.IsInTranslationEditorMode = this.props.masterViewModel.IsInTranslationEditorMode;
    }

    //will execute this setState AFTER the state has receieved all the props. 
    componentDidMount() {
        var state = this.state;

        if (!state.CatMakeModelValid) {
            state.HighlightErrors.ManufacturerSelected = true;
            state.HighlightErrors.ModelSelected = true;
            state.HighlightErrors.CategorySelected = true;
            state.FormErrors.push("Invalid Category / Manufacturer / Model Combination");

            this.handleFormUpdate(state);
        }
    }

    componentWillReceiveProps(Props) {
        this.setState({
            specsViewModel: Props.specsViewModel,
            IsAttachment: Props.model.IsAttachment,
        });

        this.modelToState(Props, true);
    }

    getTranslation(key) {
        return this.state.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: this.state.Translations[key] }}></span> :
            this.state.Translations[key];
    }

    //validation is done in ListingDetail Controller, ajax call goes to ValidateListingDetail
    //results from the ajax call are used to render react components
    validateView() {

        var validationObject = {
            highlightErrors: {},
            inputErrors: {},
            formErrors: [],
        };

        var state = this.state

        var objectToSend = {
            ManufacturerSelected: state.ManufacturerSelected,
            ModelSelected: state.ModelSelected,
            CategorySelected: state.CategorySelected,
            IsAttachment: state.IsAttachment,
            SerialVIN: state.SerialVIN,
            EquipmentIdentifier: state.EquipmentIdentifier,
            YearSelected: state.YearSelected,
            StockNumber: state.StockNumber,
            Condition: state.Condition,
            Description: state.Description,
            Quantity: state.Quantity,
            Weight: state.Weight,
            BaseCatID: state.BaseCatID
        }

        //Ajax Call
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var response = JSON.parse(xhr.response);
            validationObject.Errors = response.oListingDetailViewModel.Errors;
        }.bind(this);

        xhr.open("POST", '/listinginput/ajax/ValidateListingDetail', false);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));

        //Validation using the errors dictionary
        if (validationObject.Errors["manufacturerRequired"]) {
            if (!state.IsAttachment) {
                validationObject.highlightErrors.ManufacturerSelected = true;
                validationObject.inputErrors.ManufacturerSelected = state.Translations["IsRequired"].replace("{0}", this.state.Translations["Manufacturer"]);
            }
        }
        if (validationObject.Errors["modelRequired"]) {
            if (!state.IsAttachment) {
                validationObject.highlightErrors.ModelSelected = true;
                validationObject.inputErrors.ModelSelected = state.Translations["IsRequired"].replace("{0}", this.state.Translations["Model"]);
            }
        }
        if (validationObject.Errors["categoryRequired"]) {
            validationObject.highlightErrors.CategorySelected = true;
            validationObject.inputErrors.CategorySelected = state.Translations["IsRequired"].replace("{0}", this.state.Translations["Category"]);
        }

        if (validationObject.Errors["yearRequired"]) {
            validationObject.highlightErrors.YearSelected = true;
            validationObject.inputErrors.YearSelected = state.Translations["IsRequired"].replace("{0}", this.state.Translations["Year"]);
        }

        if (validationObject.Errors["serialRequired"]) {
            validationObject.highlightErrors.SerialVIN = true;
            validationObject.inputErrors.SerialVIN = state.Translations["IsRequired"].replace("{0}", this.state.Translations["SerialVIN"]);
        }

        if (state.TailNumber == "" && state.CurrentSite == "Aircraft") {
            validationObject.highlightErrors.TailNumber = true;
            validationObject.inputErrors.TailNumber = state.Translations["IsRequired"].replace("{0}", this.state.Translations["TailNumber"]);
        }

        if (validationObject.Errors["yearOrSerialRequired"]) {
            validationObject.formErrors.push(this.getTranslation("YearOrVinRequired"));
            validationObject.highlightErrors.YearSelected = true;
            validationObject.highlightErrors.SerialVIN = true;
            validationObject.inputErrors.YearSelected = "";
            validationObject.inputErrors.SerialVIN = "";

            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        var locationResult = validateLocation(this.props.masterViewModel.ContactViewModel.LocationViewModel, state.Translations);
        if (locationResult.hasError) {
            validationObject.highlightErrors.LocationPicker = true;
            validationObject.inputErrors.LocationPicker = locationResult.errorText;
        } else {
            delete validationObject.highlightErrors.LocationPicker;
            delete validationObject.inputErrors.LocationPicker;
        }

        return validationObject;
    }

    validatorListingDetail(bSaveXML) {
        var state = this.state;

        var bHasErrors = false;
        var validation = this.validateView();
        var highlightErrors = validation.highlightErrors;
        var inputErrors = validation.inputErrors;
        var formErrors = validation.formErrors;

        //validate specs on listing detail page
        //don't even bother if we have empty category or empty specs
        if (this.state.specsViewModel != null) {
            if (this.state.CategorySelected != "0" && this.state.specsViewModel.oMMMCategoryGroupSpecs.length > 0 && this.state.specsViewModel.GroupIndex >= 0) {
                var spec = this.state.specsViewModel.oMMMCategoryGroupSpecs[this.state.specsViewModel.GroupIndex].Specs[this.state.specsViewModel.SpecIndex];

                var validatorObject = this.props.masterViewModel.ValidateSpec(spec, this.state.specsViewModel);

                //highilight specs error.
                if (Object.keys(validatorObject.inputErrors).length != 0) {
                    highlightErrors[spec.SpecField] = validatorObject.highlightErrors[spec.SpecField];
                    inputErrors[spec.SpecField] = validatorObject.inputErrors[spec.SpecField];
                }
                else {
                    delete highlightErrors[spec.SpecField];
                    delete inputErrors[spec.SpecField];
                }
            }
        }

        //check if any errors
        bHasErrors = Object.keys(inputErrors).length > 0;

        if (state.CurrentSite == "Aircraft" && !bHasErrors) {
            //validate cat make model.
            validation = this.validateCatMakeModel(state);

            bHasErrors = validation.bHasErrors;
            highlightErrors = validation.highlightErrors;
            inputErrors = validation.inputErrors;
            formErrors = validation.formErrors;
        }

        //reset highlighted modal fields to no borders
        $("#Manufacturer").attr("style", "border: 0px solid #f38c20 !important;");
        $("#Model").attr("style", "border: 0px solid #f38c20 !important;");
        $("#Year").attr("style", "border: 0px solid #f38c20 !important;");

        if (!bHasErrors) {

            if (bSaveXML) {
                var objectToSend = {
                    SystemOfMeasurement: state.SystemOfMeasurement,
                    ManufacturerSelected: state.ManufacturerSelected,
                    ModelSelected: state.ModelSelected,
                    SerialVIN: state.SerialVIN,
                    YearSelected: state.YearSelected,
                    EquipmentIdentifier: state.EquipmentIdentifier,
                    StockNumber: state.StockNumber,
                    Condition: state.Condition,
                    Description: state.Description,
                    Quantity: state.Quantity,
                    Weight: state.Weight,
                    CategorySelected: state.CategorySelected,
                    BaseCatID: state.BaseCatID,
                }

                //save this xml
                var xhr = new XMLHttpRequest();
                xhr.open("POST", '/listinginput/listingdetail/savexml' + this.state.QueryString, true);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(JSON.stringify(objectToSend));
            }

            bHasErrors = false;
        }

        this.setState({
            HighlightErrors: highlightErrors,
            InputErrors: inputErrors,
            FormErrors: formErrors,
        });

        if (bHasErrors) {
            // Scroll to the first error field, falling back to the top of the page
            var firstErrorKey = Object.keys(highlightErrors)[0];
            var firstErrorElement = firstErrorKey ? $('#' + firstErrorKey) : null;
            if (firstErrorElement && firstErrorElement.length) {
                ScrollToElement(firstErrorElement);
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }

        return bHasErrors
    }

    validateCatMakeModel(state) {
        var validationObject = {
            highlightErrors: {},
            inputErrors: {},
            formErrors: [],
            bHasErrors: false
        };

        var objectToSend = {
            ManufacturerSelected: state.ManufacturerSelected,
            ModelSelected: state.ModelSelected,
            CategorySelected: state.CategorySelected,
            BaseCatID: state.BaseCatID,
        };

        //save this xml
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            state = this.state;

            //check if the make/model is valid. if not show error message
            var response = JSON.parse(xhr.response);

            if (response.IsValidCatMakeModel) {
                state.ManufacturerSelected = response.oListingDetailViewModel.ManufacturerSelected
                state.ModelSelected = response.oListingDetailViewModel.ModelSelected
                state.CategorySelected = response.oListingDetailViewModel.CategorySelected

                this.handleFormUpdate(state);
                this.state.updateMakeModel(state);
            }
            else {
                validationObject.highlightErrors.ManufacturerSelected = true;
                validationObject.highlightErrors.ModelSelected = true;
                validationObject.highlightErrors.CategorySelected = true;
                validationObject.formErrors.push("Invalid Category / Manufacturer / Model Combination");
                validationObject.bHasErrors = true;
            }
        }.bind(this);

        xhr.open("POST", '/listinginput/ajax/validateCatMakeModel' + this.state.QueryString, false);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));

        return validationObject;
    }

    //updates the state with new values when they change. 
    handleFormUpdate(Model) {
        this.setState({
            specsViewModel: Model.specsViewModel || this.state.specsViewModel,
            updateMakeModel: Model.updateMakeModel || this.state.updateMakeModel,
            SystemOfMeasurement: Model.SystemOfMeasurement,
            ManufacturerSelected: Model.ManufacturerSelected,
            ManufacturersList: Model.ManufacturersList,
            ModelSelected: Model.ModelSelected,
            ModelList: Model.ModelList,
            SerialVIN: Model.SerialVIN,
            SerialVINSelection: Model.SerialVINSelection,
            TailNumber: Model.TailNumber,
            AllYears: Model.AllYears,
            YearSelected: Model.YearSelected,
            Years: Model.Years,
            EquipmentIdentifier: Model.EquipmentIdentifier,
            StockNumber: Model.StockNumber,
            Condition: Model.Condition,
            ConditionList: Model.ConditionList,
            Description: Model.Description,
            Quantity: Model.Quantity,
            Weight: Model.Weight,
            ValidFECategories: Model.ValidFECategories,
            ShowFE: Model.ShowFE,
            VinSerialVerify: Model.VinSerialVerify,
            LocationViewModel: Model.LocationViewModel,
            QueryString: Model.QueryString,
            NextPageURL: Model.NextPageURL,
            Translations: Model.Translations,
            Progress: Model.Progress,
            CurrentSite: Model.CurrentSite,
            HighlightErrors: Model.HighlightErrors,
            FormErrors: Model.FormErrors,
            InputErrors: Model.InputErrors,
            MLAutofilled: Model.MLAutofilled,
            AutofilledFields: Model.AutofilledFields,
            CategorySelected: Model.CategorySelected,
            InventoryType: Model.InventoryType
        });

        //update master view 
        this.handleMasterViewUpdate(Model);
    }

    handleCategoryUpdate(Model) {
        this.setState({
            CategorySelected: Model.CategorySelected,
            CategoriesList: Model.CategoriesList,
            validFECat: Model.validFECat,
            FleetEvalElement: Model.FleetEvalElement,
            MakeOnlyCategoryOptions: Model.MakeOnlyCategoryOptions,
            AllCategories: Model.AllCategories,
            allCategoryOptions: Model.allCategoryOptions,
            InventoryType: Model.InventoryType,
            BaseCatID: Model.BaseCatID,
            bModelIsRequired: Model.bModelIsRequired,
            ModelSelected: Model.ModelSelected
        });
    }

    //Updates ViewModels in the Master View, then the MasterView will pass it down to the other child react components
    handleMasterViewUpdate(Model) {
        var masterViewModel = this.props.masterViewModel;
        masterViewModel.ListingDetailViewModel = Model;
        // Sync LocationViewModel to the master ContactViewModel
        if (Model.LocationViewModel) {
            if (masterViewModel.ContactViewModel) {
                masterViewModel.ContactViewModel.LocationViewModel = Model.LocationViewModel;
                // Create a new reference so React detects the change in child components (e.g., ContactSection)
                masterViewModel.ContactViewModel = { ...masterViewModel.ContactViewModel };
            }
        }

        if (Model.specsViewModel != null)
            masterViewModel.SpecsViewModel = Model.specsViewModel;

        this.props.handleFormUpdate(masterViewModel);
    }

    ConfirmButton() {
        Spinner.Show($('#pagebody'), true);

        var objectToSend = {
            SystemOfMeasurement: this.state.SystemOfMeasurement,
            ManufacturerSelected: $("#Manufacturer").val(),
            ModelSelected: $("#Model").val(),
            SerialVIN: this.state.SerialVIN,
            YearSelected: $("#Year").val(),
            EquipmentIdentifier: this.state.EquipmentIdentifier,
            StockNumber: this.state.StockNumber,
            Condition: this.state.Condition,
            Description: this.state.Description,
            Quantity: this.state.Quantity,
            Weight: this.state.Weight,
            CategorySelected: $("#Category").attr("datavalue"),
            BaseCatID: this.state.BaseCatID
        };

        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var response = JSON.parse(xhr.response);
            window.location = response.oListingDetailViewModel.NextPageURL;
        }.bind(this);

        xhr.open("POST", '/listinginput/listingdetail/next' + this.state.QueryString, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));
    }

    SkipButton() {
        Spinner.Show($('#pagebody'), true);

        var objectToSend = {
            SystemOfMeasurement: this.state.SystemOfMeasurement,
            ManufacturerSelected: this.state.ManufacturerSelected,
            ModelSelected: this.state.ModelSelected,
            SerialVIN: this.state.SerialVIN,
            YearSelected: this.state.YearSelected,
            EquipmentIdentifier: this.state.EquipmentIdentifier,
            StockNumber: this.state.StockNumber,
            Condition: this.state.Condition,
            Description: this.state.Description,
            Quantity: this.state.Quantity,
            Weight: this.state.Weight,
            CategorySelected: this.state.CategorySelected,
            BaseCatID: this.state.BaseCatID
        };

        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var response = JSON.parse(xhr.response);
            window.location = response.oListingDetailViewModel.NextPageURL;
        }.bind(this);

        xhr.open("POST", '/listinginput/listingdetail/next' + this.state.QueryString, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(JSON.stringify(objectToSend));
    }

    //the html and react components to render
    render() {
        var form = [];

        if (this.state.CurrentSite == "Aircraft") {
            form.push(
                <ListingDetailAircraftForm  //renders the form component here
                    key="listingDetailAircraftForm"
                    model={this.state}
                    specsViewModel={this.state.specsViewModel ?? this.props.specsViewModel}
                    SaveSpecsToXML={this.props.masterViewModel.SaveSpecsToXML}
                    showUnitSwitchModal={this.props.masterViewModel.showUnitSwitchModal}
                    contactViewModel={this.props.masterViewModel.ContactViewModel}
                    handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                    handleCategoryUpdate={(e) => { this.handleCategoryUpdate(e); }}
                    handleMasterViewUpdate={(e) => { this.handleMasterViewUpdate(e); }}
                />
            );
        }
        else {
            form.push(
                <ListingDetailForm  //renders the form component here
                    key="listingDetailForm"
                    model={this.state}
                    specsViewModel={this.state.specsViewModel ?? this.props.specsViewModel}
                    ValidateSpec={this.props.masterViewModel.ValidateSpec}
                    SaveSpecsToXML={this.props.masterViewModel.SaveSpecsToXML}
                    showUnitSwitchModal={this.props.masterViewModel.showUnitSwitchModal}
                    contactViewModel={this.props.masterViewModel.ContactViewModel}
                    handleFormUpdate={(e) => { this.handleFormUpdate(e); }}
                    handleCategoryUpdate={(e) => { this.handleCategoryUpdate(e); }}
                    handleMasterViewUpdate={(e) => { this.handleMasterViewUpdate(e); }}
                    masterViewModel={this.props.masterViewModel}
                    handlePriceFormUpdate={(e) => { this.props.handleFormUpdate(e); }}
                />
            );
        }

        return (
            form
        );
    }
}

export default ListingDetailSection;
global.ListingDetailSection = ListingDetailSection;
